import * as React from "react";

import { useDevice } from "@/hooks/useDevice";
import { BaseTemplate } from "@/layouts/BaseTemplate";
import { NavigationPath } from "@/utilities/enums";

import { OfferPcView } from "./components/pc/OfferPcView";

export const OfferListPage: React.FC = () => {
  const { isMobile } = useDevice();
  return (
    <BaseTemplate
      headerTitle={isMobile ? "メッセージ" : undefined}
      navigationPath={NavigationPath.OFFER}
      isDense
      isPcV2
    >
      <OfferPcView />
    </BaseTemplate>
  );
};
